import React from 'react';
import PropTypes from 'prop-types';
/* START CUSTOMIZATION
import { defineMessages, useIntl } from 'react-intl';
END CUSTOMIZATION */
import isEqual from 'lodash/isEqual';

import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { default as ListingBody } from '@plone/volto/components/manage/Blocks/Listing/ListingBody';
import ListingData from '@plone/volto/components/manage/Blocks/Listing/ListingData';

import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';

/* START CUSTOMIZATION
const messages = defineMessages({
  results: {
    id: 'Results preview',
    defaultMessage: 'Results preview',
  },
  items: {
    id: 'Contained items',
    defaultMessage: 'Contained items',
  },
});
END CUSTOMIZATION */

const Edit = React.memo(
  (props) => {
    const { data, onChangeBlock, block, selected, pathname } = props;
    /* START CUSTOMIZATION
    const intl = useIntl();
    const placeholder =
      data.placeholder ||
      (data?.querystring?.query?.length
        ? intl.formatMessage(messages.results)
        : intl.formatMessage(messages.items));
    END CUSTOMIZATION */

    return (
      <>
        {/* START CUSTOMIZATION
        <p className="items-preview">{placeholder}</p>
        END CUSTOMIZATION */}
        <ListingBody {...props} path={getBaseUrl(pathname)} isEditMode />
        <SidebarPortal selected={selected}>
          <ListingData
            key={block}
            {...props}
            data={data}
            block={block}
            onChangeBlock={onChangeBlock}
          />
        </SidebarPortal>
      </>
    );
  },
  function areEquals(prevProps, nextProps) {
    return !(
      nextProps.selected !== prevProps.selected ||
      !isEqual(prevProps.data, nextProps.data)
    );
  },
);

Edit.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  index: PropTypes.number.isRequired,
  selected: PropTypes.bool.isRequired,
  block: PropTypes.string.isRequired,
  onSelectBlock: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.any),
  properties: PropTypes.objectOf(PropTypes.any).isRequired,
  pathname: PropTypes.string.isRequired,
};

export default withBlockExtensions(Edit);
